import styled from '@emotion/styled';
import { BaseTabPanel, BaseTabs, colors, Stack, TabPanelContainer } from '@ui-components/neo.tax';
import { ReactComponent as CloseIcon } from '@ui-components/neo.tax/dist/icons/close.svg';

import { AscTicketsPane } from '../asc-tickets-pane';

export const StyledCloseIcon = styled(CloseIcon)({
  color: colors.primary[600],
});

export const StyledBaseTabs = styled(BaseTabs)<{ color: string }>(
  {
    padding: '4px 16px 0 16px',
  },
  ({ color }) => ({
    color: color,
  }),
);

export const StyledStack = styled(Stack)({
  minHeight: '100%',
  overflow: 'scroll',
});

export const StyledTabPanelContainer = styled(TabPanelContainer)({
  height: '100%',
  overflowY: 'auto',
  flexBasis: '0',
  flexGrow: '1',
});

export const StyledBaseTabPanel = styled(BaseTabPanel)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 0,
});

export const StyledAscTicketsPane = styled(AscTicketsPane)({
  flexBasis: '0',
  flexGrow: '1',
});

export const StyledDivider = styled.hr({
  border: 'none',
  borderTop: `1px solid ${colors.gray[200]}`,
  margin: 0,
  width: '100%',
});

export const StyledDangerZone = styled(Stack)({
  marginTop: 'auto',
  paddingTop: 24,
});
